/**
 * 存储localStorage
 */
function setStorage (key, value) {
  if (!key.trim()) { return }

  if (typeof content !== 'string') {
    value = JSON.stringify(value)
  }
  window.localStorage.setItem(key, value)
}

/**
 * 获取localStorage
 */
function getStorage (key) {
  if (!key.trim()) { return }
  try {
    return JSON.parse(window.localStorage.getItem(key))
  } catch (e) {
    return window.localStorage.getItem(key)
  }
}

/**
 * 删除localStorage
 */
function removeStorage (key) {
  if (!key) { return }
  window.localStorage.removeItem(key)
}

export {
  setStorage,
  getStorage,
  removeStorage
}
